import { DropdownMenuLabel } from '@nesso/ui/primitives/dropdown-menu';

type Props = {
    email: string;
};

// The session carries only an email — no display name — so that is the whole identity shown here.
export function AdminUserDropdownInfo({ email }: Props) {
    return (
        <DropdownMenuLabel>
            <p className="text-popover-foreground truncate">{email}</p>
        </DropdownMenuLabel>
    );
}
